/**
* =========================================================================================
* Component - Popup
* =========================================================================================
**/

import React, { useEffect, useRef } from 'react';
import Popup from 'reactjs-popup';
import {isInApp} from "../common/function";

const UPopup = (props) => {

    const popupRef = useRef(null);

    useEffect(() => {
        document.querySelector('.u_layout')?.addEventListener('wheel', handleWheel, { passive: true });

        return () => document.querySelector('.u_layout')?.removeEventListener("wheel", handleWheel);
    }, []);

    const handleWheel = (e) => {
        if(popupRef?.current) popupRef?.current?.close();
    }

    useEffect(() => {
        if(!props?.open) {
            popupRef?.current?.close();
        }
        props?.close?.();
    }, [props?.open]);

    // Close popup on inner child click
    useEffect(() => {
        if (popupRef.current) popupRef.current.close();
        props?.closeMenuOpen?.();
    }, [props?.closeMenu]);

    return (
        <React.Fragment>
            {/*<Popup*/}
            {/*    ref={popupRef}*/}
            {/*    trigger={open => (props?.children)}*/}
            {/*    arrow={props?.arrow || true}*/}
            {/*    on={['hover', 'focus']}*/}
            {/*    position="bottom center"*/}
            {/*    closeOnDocumentClick*/}
            {/*    repositionOnResize*/}
            {/*    keepTooltipInside={true}*/}
            {/*    {...props?.params}*/}
            {/*>*/}
            {/*    { props?.desc }*/}
            {/*</Popup>*/}
            {
                (!isInApp() || props.inModal === undefined)? <Popup
                        ref={popupRef}
                        trigger={open => (props?.children)}
                        arrow={props?.arrow || true}
                        on={['hover', 'focus']}
                        position="bottom center"
                        closeOnDocumentClick
                        repositionOnResize
                        keepTooltipInside={true}
                        {...props?.params}
                    >
                        {props?.desc}
                    </Popup> :
                    <Popup
                        modal
                        className="u_modal-popup u_tooltip"
                        trigger={open => (props?.children)}>
                        <span className="u_tooltip">{props?.desc}</span>
                    </Popup>
            }
        </React.Fragment>
    );
}

export default UPopup;
